export const filterTicketActivity = (entries = [], filter = 'all') => [...(entries || [])].reverse().filter(entry => {
  if (filter === 'comments') return entry.action === 'commented' || !!entry.note?.trim() || !!entry.images?.length;
  if (filter === 'operations') return entry.action !== 'commented';
  return true;
});

export const getTicketConversationPage = (entries, filter = 'all', visibleCount = 20) => {
  const filtered = filterTicketActivity(entries, filter);
  return {
    messages: filtered.slice(0, visibleCount).reverse(),
    total: filtered.length,
    hasOlder: filtered.length > visibleCount
  };
};
